import { RootState } from '../rootReducer';

export const checkIsConsentAsked = (state: RootState): boolean => state.system.isConsentAsked;
export const getAnalyticsPermission = (state: RootState): boolean => state.system.analyticsPermission;
